import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/public-thesis-portal/components/HeroSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/public-thesis-portal/components/PublicHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/public-thesis-portal/components/ThesisBrowser.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AppLogo.tsx");
